module.exports = __webpack_public_path__ + "static/img/1.25ccf32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mimg/1.jpg
// module id = Z1gm
// module chunks = 3 4